import axios from "axios";

const state = () => ({
    items: [],
    totalCount: 0,
    isBusy: false
})

// getters
const getters = {
    isBusy: state => state.isBusy,
    items: state => state.items,
    totalCount: state => state.totalCount,
}

// mutations
const mutations = {
    setItems(state, data) {
        state.items = data;
    },
    setIsBusy(state, data) {
        state.isBusy = data;
    },
    setTotalCount(state, data) {
        state.totalCount = data;
    }
}

// actions
const actions = {
    loadSegments({commit}, data) {
        commit('setIsBusy', true);
        axios.get(`/api/segments?limit=${data.params.limit}&offset=${data.params.offset}${createFilterQuery(data.filters)}${data.sort}`)
            .then(function (response) {
                commit('setItems', response.data.items);
                commit('setTotalCount', response.data.totalCount);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    saveCampaign(context, payload) {
        const method = payload.actionType === 'edit' ? 'patch' : 'post';
        const url = payload.actionType === 'edit' ? `/api/inbox/campaign/${payload.id}` : `/api/inbox/campaign`;

        return new Promise((resolve, reject) => {
            axios[method](url, payload)
                .then(resp => {
                    resolve(resp);
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    deleteCampaign(context, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/inbox/campaign/${id}`)
                .then(resp => {
                    resolve(resp);
                })
                .catch(error => {
                    reject(error);
                });
        })
    }
}

function createFilterQuery(query) {
    let filter = '';
    Object.keys(query).forEach(key => {
        filter += query[key];

        if (key === 'phone') {
            filter += '&filters[phone][0][operator]=like'
        }

        if (key === 'phrase') {
            filter += '&filters[phrase][0][operator]=like'
        }
    })
    return filter;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
